module.exports = __webpack_public_path__ + "img/Refrigerator.71392459.svg";